export const getArrowDownIcon = () => `
    <svg data-testid="ArrowDownIcon" role="img" viewBox="0 0 14 16" height="16" width="16" class="Svg__StyledSvg-sc-10xr3lw-0 lmQELN">
        <g>
        <polyline fill="none" stroke="currentColor" stroke-linecap="round" points="3 6 7 10 11 6"></polyline>
        </g>
    </svg>`;
export const getArrowUpIcon = () => `
    <svg data-testid="ArrowUpIcon" role="img" viewBox="0 0 14 16" height="16" width="16" class="Svg__StyledSvg-sc-10xr3lw-0 lmQELN">
        <g>
            <polyline fill="none" stroke="currentColor" stroke-linecap="round" points="3 10 7 6 11 10"></polyline>
        </g>
    </svg>`;
